export default {
  items: [
    {
      label: 'Dashboard',
      href: '/gb/dashboard',
      icon: 'fa-solid fa-chart-line',
      activeUrl: '/gb/dashboard',
      show: (store) => store.hasFeature('gb_content_dashboard')
    },
    {
      label: 'Moments',
      href: '/gb/moments',
      icon: 'fa-solid fa-location-dot',
      activeUrl: '/gb/moments'
    },
    {
      label: 'Businesses',
      href: '/gb/businesses',
      icon: 'fa-solid fa-store',
      activeUrl: '/gb/businesses'
    },
    {
      label: 'Widgets',
      href: '/gb/widgets',
      icon: 'fa-solid fa-code',
      activeUrl: '/gb/widgets'
    },
    {
      label: 'ServiceTitan',
      href: '/gb/service_titan/jobs',
      icon: 'fa-solid fa-wrench',
      activeUrl: '/gb/service_titan',
      show: (store) => store.hasFeature('service_titan')
    },
    {
      label: 'CompanyCam',
      href: '/gb/company_cam/projects',
      icon: 'fa-solid fa-camera',
      activeUrl: '/gb/company_cam',
      show: (store) => store.hasFeature('company_cam')
    },
    {
      label: 'About',
      href: '/gb/about',
      icon: 'fa-solid fa-circle-info',
      activeUrl: '/gb/about'
    }
  ]
}
